/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_f1_stats_how_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The Race Results tab shows real on-track performance: average qualifying and finishing positions, podium rate, DNF rate, and positions gained per race. These numbers tell you how a driver actually performs.`)
};

const es_f1_stats_how_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La pestaña de Resultados de Carrera muestra el rendimiento real en pista: posiciones promedio de clasificación y llegada, tasa de podios, tasa de abandonos y posiciones ganadas por carrera. Estos números te dicen cómo rinde realmente un piloto.`)
};

const de_f1_stats_how_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Der Rennergebnisse-Tab zeigt die echte Streckenleistung: durchschnittliche Qualifying- und Zielposition, Podiumsrate, Ausfallrate und gewonnene Positionen pro Rennen. Diese Zahlen zeigen, wie ein Fahrer tatsächlich performt.`)
};

const nl_f1_stats_how_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het tabblad Raceresultaten toont echte baanprestaties: gemiddelde kwalificatie- en finishposities, podiumpercentage, uitvalpercentage en gewonnen posities per race. Deze cijfers laten zien hoe een coureur echt presteert.`)
};

const fr_f1_stats_how_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L’onglet Résultats de Course montre les performances réelles en piste : positions moyennes en qualification et à l’arrivée, taux de podiums, taux d’abandons et positions gagnées par course. Ces chiffres vous montrent comment un pilote performe réellement.`)
};

const it_f1_stats_how_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La scheda Risultati Gara mostra le prestazioni reali in pista: posizioni medie in qualifica e arrivo, percentuale di podi, percentuale di ritiri e posizioni guadagnate per gara. Questi numeri ti dicono come un pilota si comporta realmente.`)
};

const pt_br2_f1_stats_how_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A aba Resultados de Corrida mostra o desempenho real na pista: posições médias em classificação e chegada, taxa de pódios, taxa de abandonos e posições ganhas por corrida. Esses números mostram como um piloto realmente performa.`)
};

const pt_f1_stats_how_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O separador Resultados de Corrida mostra o desempenho real na pista: posições médias em qualificação e chegada, taxa de pódios, taxa de abandonos e posições ganhas por corrida. Estes números mostram como um piloto realmente se comporta.`)
};

const ja_f1_stats_how_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`レース結果タブは実際のサーキットパフォーマンスを表示：平均予選順位と平均フィニッシュ順位、表彰台率、DNF率、レースごとの獲得ポジション。これらの数字はドライバーの実際のパフォーマンスを示しています。`)
};

const zh_f1_stats_how_p1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`比赛成绩标签显示真实赛道表现：平均排位赛和完赛位置、领奖台率、退赛率和每场比赛位置提升数。这些数字展示了车手的真实表现。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const f1_stats_how_p1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.f1_stats_how_p1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("f1_stats_how_p1", locale)
	if (locale === "en") return en_f1_stats_how_p1(inputs)
	if (locale === "es") return es_f1_stats_how_p1(inputs)
	if (locale === "de") return de_f1_stats_how_p1(inputs)
	if (locale === "nl") return nl_f1_stats_how_p1(inputs)
	if (locale === "fr") return fr_f1_stats_how_p1(inputs)
	if (locale === "it") return it_f1_stats_how_p1(inputs)
	if (locale === "pt-BR") return pt_br2_f1_stats_how_p1(inputs)
	if (locale === "pt") return pt_f1_stats_how_p1(inputs)
	if (locale === "ja") return ja_f1_stats_how_p1(inputs)
	return zh_f1_stats_how_p1(inputs)
};